import { type SupportedColorScheme } from '@mui/material';

export const forceThemeProps = (theme?: SupportedColorScheme) =>
  theme
    ? {
        'data-mui-color-scheme': theme,
      }
    : {};
